import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, inject, isDevMode } from "@angular/core";
import { IUser, LG_APP_INFO, LG_USER_INFO, VersionService } from "@logex/framework/lg-application";
import { LgReleaseNotesService, SidebarHelpStandardLinks } from "@logex/framework/lg-layout";
import { HELP_LINKS } from "@shared";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ApplicationPermissions } from "shared/app-permissions";

// entry component
// eslint-disable-next-line @angular-eslint/use-component-selector
@Component({
    templateUrl: "./authorized.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuthorizedComponent implements OnDestroy {
    appInfo = inject(LG_APP_INFO);
    helpLinks: SidebarHelpStandardLinks = inject(HELP_LINKS);
    releaseNotes = inject(LgReleaseNotesService);
    userInfo = inject(LG_USER_INFO);
    private _versionService = inject(VersionService<any>);
    private _cdr = inject(ChangeDetectorRef);
    _devMode: boolean;
    _currentProductIcon: string;
    _internal: boolean;
    _viewSettings: boolean;
    _userMessages: number;
    _refresh: boolean;

    _showTicketManager: boolean;
    _showScenarioButton: boolean;
    _notesCountTM: number;

    private readonly _destroyed$ = new Subject<void>();

    constructor() {
        this._internal = this.userInfo.hasPermission(ApplicationPermissions.INTERNAL);

        /* this._viewSettings = userInfo.hasPermission( _permissions.ViewSettings );
        this._refresh = userInfo.hasPermission( _permissions.EditSettings );*/
        this._showTicketManager = true || this._canViewTicketManager(this.userInfo);
        this._showScenarioButton = this.userInfo.hasPermission(
            ApplicationPermissions.SCENARIO_ACCESS
        );
        this._devMode = isDevMode();
        this._versionService.initialize();
        this._currentProductIcon =
            "icon-product-logo-36x36_" + this.appInfo.productId.toLowerCase();

        this.releaseNotes.isNew.pipe(takeUntil(this._destroyed$)).subscribe(val => {
            this._userMessages = val ? 1 : 0;
            this._cdr.markForCheck();
        });
    }

    private _canViewTicketManager(userInfo: IUser): boolean {
        return userInfo.hasPermission(ApplicationPermissions.ADMIN);
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
